var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sword-warning-message-wuk"},[_c('sword-icon-wuk',{attrs:{"name":"warning"}}),_c('span',{staticClass:"t4 text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }